import {
    ADD_SHIPMENT_IDENTIFIER,
    CHANGE_CONNECTIONS,
    CHANGE_REQUEST,
    CLEAR_PROVIDER,
    CLEAR_REQUEST,
    CLOSE_SNACKBAR,
    DISABLE_CONNECTION_OPERATIONS,
    UPDATE_CURRENT_ACCOUNT_TYPE,
    UPDATE_CONNECTION_TYPE,
    DISPLAY_SNACKBAR,
    ENABLE_CONNECTION_OPERATIONS,
    FILTER_CONNECTIONS,
    GET_AGREEMENTS,
    GET_CONNECTIONS,
    GET_GROUPNAMES,
    GET_SHIPPER_CODES,
    GET_PROVIDER_ACCOUNTS,
    HIDE_TABLE,
    RESET_AGREEMENT_LIST,
    RESET_SELECTED_DATASOURCE,
    SELECTED_CONNECTION,
    SET_DATASOURCE,
    SET_NEW_AGREEMENTS,
    SET_SELECTED_DATASOURCE,
    SET_SELECTED_SHIPPER,
    SHOW_TABLE,
    UPDATE_NEW_AGREEMENT,
    SHIPPER_CODES_LOADED,
    SET_DATASOURCE_CHECKCALLTYPE,
    CHECK_CALL_UPDATE_FLAG,
    CHECK_CALL_DELAY_FLAG,
    CLEAR_CHECK_CALL_DATA,
    CHECK_CALL_FETCH_FLAG,
    SET_SELECTED_GROUP_NAME,
    CONNECTION_CURRENT_OPERATION,
    CLEAR_GROUPNAMES,
    SHIPPER_GROUP_LOADED,
    SHOW_AGREEMENTS,
    HIDE_AGREEMENTS,
    IS_ACCOUNTS_LOADED,
    ACCOUNT_TYPE_LOADED,
    CREATE_NEW_CONNECTION,
    GET_SELECTED_PROVIDER_DETAILS,
    AGREEMENT_SAVE_FLAG,
    STORE_NEW_CONNECTION_ID,
    GET_TIMEZONES,
    SET_SORT_ORDER,
    SET_SORT_FIELD,
    GET_ACCOUNT_TYPES,
    UPDATE_SELECTED_ACCOUNT_TYPE
} from '../actions/types';
import { updateObject } from 'store/utility';

const initialState = {
    connections: [],
    orderedConnections: [],
    page: 1,
    pageSize: 10,
    sortOrder: 'ASC',
    sortField: 'name',
    totalElements: 0,
    groupNames: [],
    providers: [],
    accountTypes: [],
    selectedAccountType: '',
    currentAccountType: '',
    connectionType: '',
    selectedConnection: {},
    agreements: [],
    identifiers: [],
    shipperCodes: [],
    dataSource: [],
    selectedDataSource: '',
    connectionId: '',
    newAgreements: [],
    snackBarOptions: {
        showSnackbar: false,
        message: '',
        variant: ''
    },
    currentOperation: '',
    disableOtherOperation: false,
    selectedShipper: '',
    agreementList: [],
    valid: false,
    isShipperCodeLoaded: false,
    dataSourceCheckCallType: {},
    checkCallFlag: false,
    checkCallDelay: false,
    checkCallFetchFlag: false,
    selectedGroupName: '',
    isShipperGroupLoaded: false,
    showAgreements: false,
    isProviderAccountsLoaded: false,
    isAccountTypeLoaded: false,
    newConnectionRequest: {},
    selectedProvider: {},
    agreementSaved: false,
    newConnectionId: '',
    timeZones: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CONNECTIONS:
            const items = action.payload.items;
            const currentPage = action.payload.currentPage;
            const totalElement = action.payload.totalItems;
            return updateObject(state, {
                connections: [...items],
                page: currentPage,
                totalElements: totalElement,
                pageSize: action.size
            });
        case GET_PROVIDER_ACCOUNTS:
            return updateObject(state, { providers: action.payload });
        case GET_ACCOUNT_TYPES:
            return updateObject(state, { accountTypes: action.payload });
        case UPDATE_SELECTED_ACCOUNT_TYPE:
            return updateObject(state, { selectedAccountType: action.payload });
        case UPDATE_CURRENT_ACCOUNT_TYPE:
            return updateObject(state, { currentAccountType: action.payload });
        case UPDATE_CONNECTION_TYPE:
            return updateObject(state, { connectionType: action.payload });
        case GET_SHIPPER_CODES:
            return updateObject(state, { shipperCodes: action.payload });
        case CLEAR_PROVIDER:
            return updateObject(state, {
                connections: action.payload,
                orderedConnections: action.payload
            });
        case SET_DATASOURCE:
            return updateObject(state, { dataSource: action.payload });
        case SELECTED_CONNECTION:
            return updateObject(state, { connectionId: action.payload });
        case GET_GROUPNAMES:
        case CLEAR_GROUPNAMES:
            return updateObject(state, { groupNames: action.payload });
        case CLEAR_CHECK_CALL_DATA:
        case SET_DATASOURCE_CHECKCALLTYPE:
            return updateObject(state, { dataSourceCheckCallType: action.payload });
        case CHECK_CALL_FETCH_FLAG:
            return updateObject(state, { checkCallFetchFlag: action.payload });
        case CHECK_CALL_UPDATE_FLAG:
            return updateObject(state, { checkCallFlag: action.payload });
        case CHECK_CALL_DELAY_FLAG:
            return updateObject(state, { checkCallDelay: action.payload });
        case GET_AGREEMENTS:
            let getAllAgreements = { ...state.agreements };
            getAllAgreements[state.connectionId] = action.payload;
            return updateObject(state, { agreements: getAllAgreements });
        case HIDE_AGREEMENTS:
        case SHOW_AGREEMENTS:
            return updateObject(state, { showAgreements: action.payload });
        case SET_NEW_AGREEMENTS:
            let allNewAgreements = [...state.newAgreements];
            allNewAgreements.push(action.payload);
            return updateObject(state, { newAgreements: allNewAgreements });
        case UPDATE_NEW_AGREEMENT:
            return updateObject(state, { newAgreements: [...action.payload] });
        case CHANGE_CONNECTIONS:
            return updateObject(state, { selectedConnection: action.payload });
        case SET_SELECTED_SHIPPER:
            return updateObject(state, { selectedShipper: action.payload });
        case SET_SELECTED_DATASOURCE:
            return updateObject(state, { selectedDataSource: action.payload });
        case SET_SORT_ORDER:
            return updateObject(state, { sortOrder: action.payload });
        case SET_SORT_FIELD:
            return updateObject(state, { sortField: action.payload });
        case SET_SELECTED_GROUP_NAME:
            return updateObject(state, { selectedGroupName: action.payload });
        case ADD_SHIPMENT_IDENTIFIER:
            let allNewAgreements1 = { ...state.newAgreements };
            allNewAgreements1[state.selectedShipper].shipment_identifier = action.payload;
            return updateObject(state, { newAgreements: allNewAgreements1 });
        case CLEAR_REQUEST:
            return updateObject(state, { newAgreements: [] });
        case DISPLAY_SNACKBAR:
            return updateObject(state, {
                snackBarOptions: {
                    showSnackbar: action.payload[0],
                    message: action.payload[1],
                    variant: action.payload[2]
                }
            });
        case CLOSE_SNACKBAR:
            return updateObject(state, {
                snackBarOptions: {
                    showSnackbar: false,
                    message: '',
                    variant: ''
                }
            });

        case FILTER_CONNECTIONS:
            const filteredConnection = state.connections.filter((data) => {
                const actualValue = action.payload.toLowerCase().trim();
                const expectedValue = data.name.toString().toLowerCase();
                return expectedValue.includes(actualValue);
            });
            return updateObject(state, { connections: filteredConnection });
        case RESET_SELECTED_DATASOURCE:
            return { ...state, selectedDataSource: '' };
        case RESET_AGREEMENT_LIST:
        case CHANGE_REQUEST:
            return { ...state, agreementList: action.payload };
        case SHOW_TABLE:
            return { ...state, valid: true };
        case HIDE_TABLE:
            return { ...state, valid: false };
        case DISABLE_CONNECTION_OPERATIONS:
            return { ...state, disableOtherOperation: true };
        case ENABLE_CONNECTION_OPERATIONS:
            return { ...state, disableOtherOperation: false };
        case SHIPPER_CODES_LOADED:
            return { ...state, isShipperCodeLoaded: action.payload };
        case SHIPPER_GROUP_LOADED:
            return updateObject(state, { isShipperGroupLoaded: action.payload });
        case CONNECTION_CURRENT_OPERATION:
            return { ...state, currentOperation: action.payload };
        case IS_ACCOUNTS_LOADED:
            return { ...state, isProviderAccountsLoaded: action.payload };
        case ACCOUNT_TYPE_LOADED:
            return { ...state, isAccountTypeLoaded: action.payload };
        case CREATE_NEW_CONNECTION:
            return { ...state, newConnectionRequest: { ...action.payload } };
        case GET_SELECTED_PROVIDER_DETAILS:
            return { ...state, selectedProvider: { ...action.payload } };
        case AGREEMENT_SAVE_FLAG:
            return { ...state, agreementSaved: action.payload };
        case STORE_NEW_CONNECTION_ID:
            return { ...state, newConnectionId: action.payload };
        case GET_TIMEZONES:
            return { ...state, timeZones: action.payload };
        default:
            return state;
    }
};
